export default "__VITE_ASSET__D$P5rrji__"